import * as Dtos from '../../dtos/Fig.dtos';
import { FileState } from '../../dtos/Fig.dtos';

export interface ISourceDocumentModalState {
    openedModals: string[];
}

export const initialSourceDocumentState: Dtos.SourceDocument = {
    id: null,
    patientId: null,
    registrationFormId: null,
    fileType: null,
    fileSize: null,
    name: null,
    extension: null,
    contentType: null,
    exists: null,
    image: null,
    fileInformation: {
        guid: null,
        progress: null,
        state: FileState.Empty,
        temporaryFile: null
    },
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null
}